import {
  ACTION_GET_FILES_ITEM_FAILURE,
  ACTION_GET_FILES_ITEM_REQUEST,
  ACTION_GET_FILES_ITEM_SUCCESS,
  ACTION_UPLOAD_FILES_ITEM_FAILURE,
  ACTION_UPLOAD_FILES_ITEM_REQUEST,
  ACTION_UPLOAD_FILES_ITEM_SUCCESS,
  ERROR_FILES_UPLOAD_SERVER,
} from '@/app/module/files/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import request from '@/app/module/request'
import { createAsyncActions, preventParallel } from '@/app/service/util'
import config from '@/config'
import http from '@/config/http'

const {
  request: getRequest,
  success: getSuccess,
  failure: getFailure,
} = createAsyncActions({
  request: ACTION_GET_FILES_ITEM_REQUEST,
  success: ACTION_GET_FILES_ITEM_SUCCESS,
  failure: ACTION_GET_FILES_ITEM_FAILURE,
})

const {
  request: uploadRequest,
  success: uploadSuccess,
  failure: uploadFailure,
} = createAsyncActions({
  request: ACTION_UPLOAD_FILES_ITEM_REQUEST,
  success: ACTION_UPLOAD_FILES_ITEM_SUCCESS,
  failure: ACTION_UPLOAD_FILES_ITEM_FAILURE,
})

export const getFilesItem = preventParallel(
  ({ orgId, name }) => `${orgId}-${name}`,
  ({ token, orgId, name }) =>
    (dispatch) => {
      dispatch(getRequest({ name }))

      const dlPath = http.files.get.getSignablePath({ orgId, name })
      const data = {
        paths: [dlPath],
      }

      return request.auth
        .sign({ token, item: data })
        .then((res) => {
          const url = http.files.get.getPath({
            name,
            signedPath: dlPath,
            urlToken: res[dlPath],
          })
          dispatch(getSuccess({ name, url, urlToken: res[dlPath] }))
          return {
            name,
            url,
          }
        })
        .catch((err) => {
          dispatch(
            getFailure({
              status: err.status,
              error: err.message,
            }),
          )
        })
    },
)

export const saveFile =
  ({ token, orgId, item }) =>
  (dispatch) => {
    dispatch(uploadRequest())

    const data = new FormData()
    data.append('upload', item.file, item.filename)

    const urlParams = new URLSearchParams()
    urlParams.append('category', 'uploads')
    if (item.type === 'video') {
      urlParams.append('video', 'true')
    }
    if (item.filter) {
      urlParams.append('filter', item.filter)
    }
    const query = urlParams.toString() ? `?${urlParams.toString()}` : ''

    return request.files
      .save({ token, orgId, file: data, query })
      .then(({ filename, title }) => {
        const url = `${config.svc.url}/v1/organizations/${orgId}/files/${filename}`
        dispatch(
          uploadSuccess({
            filename,
            title,
            url,
          }),
        )
        return {
          filename,
          title,
          url,
        }
      })
      .catch((err) => {
        dispatch(
          uploadFailure({
            status: err.status,
            error: err.message,
          }),
        )
        dispatch(
          createNotification({
            'upload-file': {
              type: 'error',
              message: ERROR_FILES_UPLOAD_SERVER,
            },
          }),
        )
        return err
      })
  }
